module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Write-72fb835033c636f8c6935d2dc144c0ca.svg";